<template>
  <div id="app">

    <section>
      <h1>Thomas Bailly-Salins</h1>
      <h2>Fullstack web developer<br>Freelance - Paris</h2>
    </section>

    <section>
      <ul>
        <li>Nodejs | Laravel</li>
        <li>Reactjs | Vuejs</li>
        <li>PostgreSQL | MongoDB</li>
        <li>AWS | Terraform</li>
      </ul>
    </section>

    <section>
      <ul>
        <li>
        <a href="https://www.linkedin.com/in/thomas-bailly-salins-012508b6" target="_blank">Linkedin</a>
        </li>
        <li>
          <a href="https://github.com/tbailly" target="_blank">Github</a>
        </li>
      </ul>
    </section>

  </div>
</template>

<script>
export default {
  name: 'App',
  components: {},
  metaInfo: {
    title: 'Thomas Bailly-Salins | Freelance fullstack web developer | Paris',
    meta: [
      { name: 'description', content: 'My name is Thomas Bailly-Salins, I\'m a fullstack web developer based in Paris. I am currently working as an independant. You can find more on my Github or Linkedin' },
    ],
    link: [
      { rel: 'canonical', href: 'https://thomasbs.fr' },
    ],
  },
};
</script>

<style lang="scss">
body {
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;

  background: #141e30;
  background: -webkit-linear-gradient(35deg, #141e30, #243b55);
  background: linear-gradient(35deg, #141e30, #243b55);
  color: #ecece4;

  ul {
    list-style: none;
    padding: 0;

    a {
      color: #ecece4;
      text-decoration: none;

      &:hover {
        color: white;
        font-weight: bold;
      }
    }
  }

  p {
    margin: 0;
  }
}
</style>
